import type { HelpFile } from '../../types/help'
import { SyncRunsTabTestIds } from '../../../testids/SyncRunsTabTestIds'

export const syncRunsTabHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [SyncRunsTabTestIds.syncRunsCard]:
      'Recent synchronisation runs for this inbound connector — start and end times, record counts, and outcomes.',
    [SyncRunsTabTestIds.syncRunDetail]:
      'Detailed view of a single synchronisation run — phase timestamps, record counts per operation, and any errors.',
    [SyncRunsTabTestIds.cardTitleSyncRecords]:
      'Per-record outcomes captured during the selected sync run.',
    [SyncRunsTabTestIds.cardTitleSyncErrorLogs]:
      'Errors recorded during this sync run — each row links to the full error log entry.',
    [SyncRunsTabTestIds.colErrorLogId]:
      'Identifier of the error log entry — click to open the full log.',
    [SyncRunsTabTestIds.colErrorLogCreatedAt]:
      'When the error was recorded.',
    [SyncRunsTabTestIds.syncRunsEmpty]:
      'Shown when no sync runs have been recorded for this connector yet.',
    [SyncRunsTabTestIds.syncRunsLoading]: null,
    [SyncRunsTabTestIds.colSyncRunType]:
      'Sync run type — full or preview (or the raw string for historical rows).',
    [SyncRunsTabTestIds.colSyncRunStatus]:
      'Outcome of the sync run (success, failed, paused, ...).',
    [SyncRunsTabTestIds.colSyncRunStarted]:
      'When the sync run started.',
    [SyncRunsTabTestIds.colSyncRunDuration]:
      'Total wall-clock duration of the sync run.',
    [SyncRunsTabTestIds.colSyncRunCreated]:
      'Number of records created during the sync run.',
    [SyncRunsTabTestIds.colSyncRunUpdated]:
      'Number of records updated during the sync run.',
    [SyncRunsTabTestIds.colSyncRunSkipped]:
      'Number of records skipped during the sync run.',
    [SyncRunsTabTestIds.colSyncRunErrored]:
      'Number of records that failed during the sync run.',
    [SyncRunsTabTestIds.colSyncRecordExternalId]:
      'External identifier of the record in the source system.',
    [SyncRunsTabTestIds.colSyncRecordEntityType]:
      'Entity type of the source record (identity, account, group, ...).',
    [SyncRunsTabTestIds.colSyncRecordAction]:
      'Action taken on the source record during sync (created, updated, deleted, skipped).',
    [SyncRunsTabTestIds.colSyncRecordCorrelatedIdentity]:
      'Identity matched to the source record by the correlation rules.',
    [SyncRunsTabTestIds.colSyncRecordProcessedAt]:
      'Time the record was processed during the sync run.',
    [SyncRunsTabTestIds.colSyncRecordErrorMessage]:
      'Error message captured when the record could not be processed.',
    [SyncRunsTabTestIds.colSyncRecordPayload]:
      'Toggle a row to view the captured staging payload (cleared after successful processing).',
  },
}
